import { Edit, SaveButton, Toolbar, useNotify, useRedirect, useResourceContext } from 'react-admin';

import { ProductArchiveButton } from './ProductArchiveButton';
import { ProductForm } from './ProductForm';
import { transformProductInput } from './json';

const ProductEditToolbar = () => (
  <Toolbar>
    <SaveButton />
    <ProductArchiveButton />
  </Toolbar>
);

export const ProductEdit = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const resource = useResourceContext();

  const onSuccess = () => {
    notify('Updated Product', { type: 'success' });
    redirect('list', resource);
  };

  return (
    <Edit mutationMode="pessimistic" transform={transformProductInput} mutationOptions={{ onSuccess }}>
      <ProductForm title="Update Product" toolbar={<ProductEditToolbar />} />
    </Edit>
  );
};
